import type { ReactNode } from "react";
import CircleIcon from "@mui/icons-material/Circle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import type { SxProps } from "@mui/material";
import { Skeleton } from "@mui/material";
import type { Presence } from "models/ContactsMetiers";

interface PresenceIconProps {
  presence?: Presence;
  isLoading?: boolean;
  fontSize?: "small" | "medium" | number;
  sx?: SxProps;
}

export function PresenceIcon({
  presence,
  isLoading = false,
  fontSize = "small",
  sx,
}: Readonly<PresenceIconProps>): ReactNode {
  if (isLoading) {
    return (
      <Skeleton
        sx={sx}
        variant="circular"
        width={typeof fontSize === "number" ? 22 : fontSize}
        height={typeof fontSize === "number" ? 22 : fontSize}
      />
    );
  }

  const styles = {
    bgcolor: "white",
    borderRadius: "100%",
    fontSize: typeof fontSize === "number" ? fontSize : undefined,
    ...sx,
  };

  return (
    presence != null &&
    // L'API étant en beta, on teste explicitement pour vérifier que la valeur existe bien
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-boolean-literal-compare
    (presence?.outOfOfficeSettings?.isOutOfOffice === true ? (
      <CircleIcon
        fontSize={typeof fontSize === "number" ? undefined : fontSize}
        color="error"
        sx={styles}
      />
    ) : (
      <CheckCircleIcon
        fontSize={typeof fontSize === "number" ? undefined : fontSize}
        color="success"
        sx={styles}
      />
    ))
  );
}
